export default __webpack_public_path__ + "static/hero-bg-d6249a1598c75a9a509ea81730b51701.png";